import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";

const COLLECTION_NAME = "drivers";

// Simple disable/enable driver function
export const toggleDriverStatus = async (driverId, driverData, disable) => {
  try {
    const newStatus = disable ? "Disabled" : "Active";

    await updateDoc(doc(db, COLLECTION_NAME, driverId), {
      status: newStatus,
      accountDisabled: disable,
      lastStatusChange: serverTimestamp(),
      updatedAt: serverTimestamp(),
      disabledBy: "admin", // Track who disabled it
      disabledReason: disable ? "Admin action" : null,
    });
    return {
      success: true,
      action: disable ? "disabled" : "enabled",
      newStatus: newStatus,
      message: `Driver ${disable ? "disabled" : "enabled"} successfully`,
    };
  } catch (error) {
    console.error("Error toggling driver status:", error);
    throw error;
  }
};

// Disable driver
export const disableDriver = async (driverId, driverData) => {
  return await toggleDriverStatus(driverId, driverData, true);
};

// Enable driver
export const enableDriver = async (driverId, driverData) => {
  return await toggleDriverStatus(driverId, driverData, false);
};
